import { Categories } from './categories';
import { MineVerktoyList } from './mine-verktoy-list';
import { AboutVerktoy } from './moreInfo';

export const EntryPage = (): React.JSX.Element => {
  return (
    <>
      <MineVerktoyList />
      <Categories />
      <AboutVerktoy />
    </>
  );
};
